const kaizan = [
  {
    id: 2,
    img: "https://i.ibb.co/tMC23Wc7/A-Simplified-Approach-to-Improve-Efficiency-and-Productivity-at-Kazi-Kazi-Tea.jpg",
    companyName:
      "A Simplified Approach to Improve Efficiency and Productivity at  Kazi & Kazi Tea",
  },
  {
    id: 3,
    img: "https://i.ibb.co/KcZ7Q86c/Designing-Lean-Factory-Total-Productive-Maintance-TPM-at-Confidence-Batteries-Limited.jpg",
    companyName:
      "Designing Lean Factory Total Productive Maintenance (TPM) at Confidence Batteries Limited.",
  },
  {
    id: 4,
    img: "https://i.ibb.co/yFNHYmFp/Drove-deep-thinking-and-core-problem-solving-through-a-team-based-Kaizen-session.jpg",
    companyName:
      "Drove deep thinking and core problem-solving through a team-based Kaizen session",
  },
  {
    id: 5,
    img: "https://i.ibb.co/kgpbYLMx/Gemba-walk-and-Kaizen-at-Apex-Footwear-Limited.jpg",
    companyName: "Gemba walk and Kaizen at Apex Footwear Limited",
  },

  {
    id: 8,
    img: "https://i.ibb.co/GQr4gWZx/Kaizen-Activities-Recognition-at-Confidence-Infrastructure-Limited.jpg",
    companyName:
      "Kaizen Activities Recognition at Confidence Infrastructure Limited",
  },

  {
    id: 10,
    img: "https://i.ibb.co/PGLTLPvB/Kaizen-implementation-at-Confidence-Power-Rangpur-Limited.jpg",
    companyName: "Kaizen implementation at Confidence Power Rangpur Limited",
  },
  {
    id: 11,
    img: "https://i.ibb.co/1GcjZ4qr/Kaizen-Implementation-Plan-at-VIVO-Mobile-Plant.jpg",
    companyName: "Kaizen Implementation Plan at VIVO Mobile Plant",
  },

  {
    id: 14,
    img: "https://i.ibb.co/V0Ydm3C3/Lean-Operations-at-Confidence-Power-Rangpur-Limited.jpg",
    companyName: "Lean Operations at Confidence Power Rangpur Limited.",
  },

  // {
  //   id: 6,
  //   img: "https://i.ibb.co/YFNwvMVz/Kaizan-6-01.png",
  // },
  // {
  //   id: 7,
  //   img: "https://i.ibb.co/sdpDcBFP/Kaizan-01.png",
  // },
  // // {
  // //   id: 8,
  // //   img: "https://i.ibb.co/wZ2HZLFm/k-2-01.jpg",
  // // },
  // {
  //   id: 9,
  //   img: "https://i.ibb.co/TqMnq1Bs/Untitled-1-Recovered-01.jpg",
  // },
  // {
  //   id: 10,
  //   img: "https://i.ibb.co/HfXy9Nr9/Untitled-1-Recovered-02.jpg",
  // },
  // {
  //   id: 11,
  //   img: "https://i.ibb.co/XkY0LDm4/Untitled-1-Recovered-03.jpg",
  // },
  // {
  //   id: 12,
  //   img: "https://i.ibb.co/N58npNY/Untitled-1-Recovered-04.jpg",
  // },
  // {
  //   id: 13,
  //   img: "https://i.ibb.co/39VXKNyq/Untitled-1-Recovered-05.jpg",
  // },
  // {
  //   id: 14,
  //   img: "https://i.ibb.co/CpHWgXnC/Untitled-1-Recovered-06.jpg",
  // },
  // {
  //   id: 15,
  //   img: "https://i.ibb.co/ch7FXp01/Untitled-1-Recovered-07.jpg",
  // },
  // {
  //   id: 16,
  //   img: "https://i.ibb.co/N2ZTbhkj/Untitled-1-Recovered-08.jpg",
  // },
  // {
  //   id: 17,
  //   img: "https://i.ibb.co/JwtJjdWj/Untitled-1-Recovered-09.jpg",
  // },
  // {
  //   id: 18,
  //   img: "https://i.ibb.co/9kSJ5x2b/Untitled-1-Recovered-10.jpg",
  // },
  // {
  //   id: 19,
  //   img: "https://i.ibb.co/VbnkDpT/Untitled-1-Recovered-11.jpg",
  // },
  // {
  //   id: 20,
  //   img: "https://i.ibb.co/ddzQB3k/Untitled-1-Recovered-12.jpg",
  // },
  // {
  //   id: 21,
  //   img: "https://i.ibb.co/k2y2PM9J/Untitled-1-Recovered-13.jpg",
  // },
  // {
  //   id: 22,
  //   img: "https://i.ibb.co/nqyqd1mC/Untitled-1-Recovered-14.jpg",
  // },
  // {
  //   id: 23,
  //   img: "https://i.ibb.co/Jj3VQ8cM/Untitled-1-Recovered-15.jpg",
  // },
  // {
  //   id: 24,
  //   img: "https://i.ibb.co/tMj1Pbj2/Untitled-1-Recovered-16.jpg",
  // },
  // {
  //   id: 25,
  //   img: "https://i.ibb.co/8k0kvgJ/Untitled-1-Recovered-17.jpg",
  // },
  // {
  //   id: 26,
  //   img: "https://i.ibb.co/NddjMrHq/Untitled-1-Recovered-18.jpg",
  // },
  // {
  //   id: 27,
  //   img: "https://i.ibb.co/fVqC2mT1/Untitled-1-Recovered-19.jpg",
  // },
  // {
  //   id: 28,
  //   img: "https://i.ibb.co/KprNRfgg/Untitled-1-Recovered-20.jpg",
  // },
  // {
  //   id: 29,
  //   img: "https://i.ibb.co/8gbwn4tn/Untitled-1-Recovered-21.jpg",
  // },
  // {
  //   id: 30,
  //   img: "https://i.ibb.co/gZ33rPXB/Untitled-1-Recovered-22.jpg",
  // },
  // {
  //   id: 31,
  //   img: "https://i.ibb.co/pV93wBc/Untitled-1-Recovered-23.jpg",
  // },
  // {
  //   id: 32,
  //   img: "https://i.ibb.co/nqyqd1mC/Untitled-1-Recovered-14.jpg",
  // },
  // {
  //   id: 33,
  //   img: "https://i.ibb.co/QFD9K0tG/Untitled-1-Recovered-25.jpg",
  // },
  // {
  //   id: 34,
  //   img: "https://i.ibb.co/mrSn1tyb/Untitled-1-Recovered-26.jpg",
  // },
  // {
  //   id: 35,
  //   img: "https://i.ibb.co/9H57538X/k-01.jpg",
  // },
  // {
  //   id: 36,
  //   img: "https://i.ibb.co/CKjCC4qB/k-02.jpg",
  // },
  // {
  //   id: 37,
  //   img: "https://i.ibb.co/tPFtX680/k-03.jpg",
  // },
  // {
  //   id: 38,
  //   img: "https://i.ibb.co/ycwnrYm9/k-04.jpg",
  // },
  // {
  //   id: 39,
  //   img: "https://i.ibb.co/k7xyGCw/k-05.jpg",
  // },
  // {
  //   id: 40,
  //   img: "https://i.ibb.co/jZgz3KG3/k-06.jpg",
  // },
  // {
  //   id: 41,
  //   img: "https://i.ibb.co/fVY7ChwY/k-07.jpg",
  // },
  // {
  //   id: 42,
  //   img: "https://i.ibb.co/215RZdN8/k-08.jpg",
  // },
  // {
  //   id: 43,
  //   img: "https://i.ibb.co/Z6BFKNDd/k-09.jpg",
  // },
  // {
  //   id: 44,
  //   img: "https://i.ibb.co/FLSQ6vhM/k-10.jpg",
  // },
  // {
  //   id: 45,
  //   img: "https://i.ibb.co/23c7SBrj/k-11.jpg",
  // },
  // {
  //   id: 46,
  //   img: "https://i.ibb.co/hJsRCnrd/k-12.jpg",
  // },
  // {
  //   id: 47,
  //   img: "https://i.ibb.co/BV36kYWR/k-13.jpg",
  // },
  // {
  //   id: 48,
  //   img: "https://i.ibb.co/3yPkLnD9/k-14.jpg",
  // },
  // {
  //   id: 49,
  //   img: "https://i.ibb.co/xqRpCDmw/k-15.jpg",
  // },
  // {
  //   id: 50,
  //   img: "https://i.ibb.co/Pv16hJPx/k-16.jpg",
  // },
  // {
  //   id: 51,
  //   img: "https://i.ibb.co/tMFtVJh0/k-17.jpg",
  // },
  // {
  //   id: 52,
  //   img: "https://i.ibb.co/NRpyD4G/k-18.jpg",
  // },
  // {
  //   id: 53,
  //   img: "https://i.ibb.co/b5RW43nP/k-19.jpg",
  // },
  // {
  //   id: 54,
  //   img: "https://i.ibb.co/bDpHvS6/k-20.jpg",
  // },
  // {
  //   id: 55,
  //   img: "https://i.ibb.co/3yL0N9ZQ/k-21.jpg",
  // },
  // {
  //   id: 56,
  //   img: "https://i.ibb.co/35pZgBL4/k-22.jpg",
  // },
  // {
  //   id: 57,
  //   img: "https://i.ibb.co/7xWmxwmZ/k-23.jpg",
  // },
  // {
  //   id: 58,
  //   img: "https://i.ibb.co/qY2J2x4h/k-24.jpg",
  // },
  // {
  //   id: 59,
  //   img: "https://i.ibb.co/TM8n0zdc/k-25.jpg",
  // },
  // {
  //   id: 60,
  //   img: "https://i.ibb.co/93Zy2MN4/k-26.jpg",
  // },
  // {
  //   id: 61,
  //   img: "https://i.ibb.co/5gxPyBfs/k-27.jpg",
  // },
  // {
  //   id: 62,
  //   img: "https://i.ibb.co/KpjNTLTR/k-28.jpg",
  // },
  // {
  //   id: 64,
  //   img: "https://i.ibb.co/fd75Pwww/k-29.jpg",
  // },
  // {
  //   id: 65,
  //   img: "https://i.ibb.co/tw0xHmmd/k-30.jpg",
  // },
  // {
  //   id: 66,
  //   img: "https://i.ibb.co/hxfm0JTw/k-31.jpg",
  // },
  // {
  //   id: 67,
  //   img: "https://i.ibb.co/jZHc2BK3/k-32.jpg",
  // },
  // {
  //   id: 68,
  //   img: "https://i.ibb.co/fYLPVCTT/k-33.jpg",
  // },
  // {
  //   id: 69,
  //   img: "https://i.ibb.co/fGKgpXdL/k-34.jpg",
  // },
  // {
  //   id: 70,
  //   img: "https://i.ibb.co/4ggGvXDD/k-35.jpg",
  // },
  // {
  //   id: 1,
  //   img: "https://i.ibb.co/x8GfLVGv/gimba-4-01.png",
  // },
  // {
  //   id: 15,
  //   img: "https://i.ibb.co/ymz3dRY0/s-s-1-04.jpg",
  // },
  // {
  //   id: 20,
  //   img: "https://i.ibb.co/W4VxLHGD/s-s-1-09.jpg",
  // },
  // {
  //   id: 22,
  //   img: "https://i.ibb.co/dJMMyjP3/s-s-1-11.jpg",
  // },
  // {
  //   id: 25,
  //   img: "https://i.ibb.co/LdTVP146/s-s-1-14.jpg",
  // },
  // {
  //   id: 31,
  //   img: "https://i.ibb.co/0wHFw0Q/s-s-1-20.jpg",
  // },
  // {
  //   id: 32,
  //   img: "https://i.ibb.co/5yNM851/s-s-1-21.jpg",
  // },
  // {
  //   id: 28,
  //   img: "https://i.ibb.co/VZmvBny/s-s-1-17.jpg",
  // },
];

export default kaizan;
